import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";
import * as Sentry from "@sentry/nextjs";
import useSWR from "swr";
import { fetcher } from "../../../../../../../common/helper";

const voteTypes = {
    UPVOTE: 'upvotes',
    DOWNVOTE: 'downvotes'
}

export default function Korisno({ korisno, id, tip = "utisak" }) {
    const [pending, setPending] = useState(false);
    const [votes, setVotes] = useState(korisno);
    const [voted, setVoted] = useState("");
    const { data: session } = useSession();

    const { data } = useSWR(
        session ? `/api/${tip}/vote?id=${id}` : null,
        fetcher
    );

    const changeVote = (type = "UPVOTE") => {
        const opositeType = type === "UPVOTE" ? "DOWNVOTE" : "UPVOTE";
        const newVotes = {
            [voteTypes[type]]: votes[voteTypes[type]] + 1,
            [voteTypes[opositeType]]: votes[voteTypes[opositeType]] - 1,
        };
        setVotes(newVotes);
        setVoted(type);
    };

    
    const handleVote = async (voteType) => {
        setPending(true);
        await fetch(
            `/api/${tip}/vote?id=${id}&type=${voteType.toLowerCase()}`,
            {
                method: "PUT",
            }
        )
            .then(async (r) => r.json())
            .then((r) => {
                setPending(false);
                if (r.added) {
                    setVoted(voteType);
                    setVotes({ ...votes, [voteTypes[voteType]]: votes[voteTypes[voteType]] + 1 });
                } else if (r.edited) {
                    changeVote(voteType);
                }

                if (voteType === voted) {
                    setVotes((state) => ({
                        ...state,
                        [voteTypes[voteType]]: state[voteTypes[voteType]] - 1,
                    }));
                    setVoted('');
                }
            })
            .catch((e) => {
                Sentry.captureException(e);
                setPending(false);
                console.log(e);
            });
    };

    useEffect(() => {
        if (data && session) {
            setVoted(data?.value);
        }
    }, [data, session]);

    return (
        <>
            <button
                disabled={pending}
                type="button"
                onClick={session ? () => handleVote("UPVOTE") : () => {}}
            >
                <div className="inline-block p-2 px-3 rounded mt-4 bg-gray-light hover:bg-gray transition-all duration-200">
                    <span className="text-base pr-2 text-gray-dark">
                        {votes.upvotes}
                    </span>
                    {voted === 'UPVOTE' ? upvoteFull : upvoteBlank}
                </div>
            </button>
            <button
                disabled={pending}
                type="button"
                onClick={session ? () => handleVote("DOWNVOTE") : () => {}}
            >
                <div className="inline-block p-2 px-3 rounded mt-4 bg-gray-light hover:bg-gray transition-all duration-200 m-4">
                    <span className="text-base pr-2 text-gray-dark">
                        {votes.downvotes}
                    </span>
                    {voted === 'DOWNVOTE' ? downvoteFull : downvoteBlank}
                </div>
            </button>
        </>
    );
}

const upvoteBlank = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="inline h-4 w-4 mb-1"
        fill="none"
        viewBox="0 0 24 24"
        stroke="#666"
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
        />
    </svg>
);

const upvoteFull = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="inline h-4 w-4 mb-1"
        viewBox="0 0 20 20"
        fill="#0160FE"
    >
        <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" />
    </svg>
);

const downvoteBlank = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="inline h-4 w-4 mb-1 rotate-180"
        fill="none"
        viewBox="0 0 24 24"
        stroke="#666"
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
        />
    </svg>
);

const downvoteFull = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="inline h-4 w-4 mb-1 rotate-180"
        viewBox="0 0 20 20"
        fill="red"
    >
        <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" />
    </svg>
);
